export default {"src":"/_next/static/media/0x4200000000000000000000000000000000000006.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};